  if (document.querySelector(".about-us-text-bg-image-box")) $(window).on("scroll", function () {
    $(".about-us-text-bg-image-box .common-box-container").each(function () {
      var t = $(window).scrollTop(),
        o = $(this).offset().top,
        e = $(this).outerHeight(),
        i = o - e;
      if (t + $(window).height() > o && t < o + e) {
        var s = -((t - i) * 0.12);
        767 > $(window).width() && (s = -((t - i) * 0.04)),
          $(this).css("background-position", "center " + s + "px");
      }
    });
  });



  $(document).ready(function(){
    $("footer input[name='contact[email]']").on("focus active", function(){
      $(this).closest(".t4s-newsletter__fields").addClass("active")
    })
    
    // 点击其他区域时移除active类
    $(document).on("click", function(e) {
      if(!$(e.target).closest(".t4s-newsletter__fields").length) {
        $(".t4s-newsletter__fields").removeClass("active");
      }
    })

  })

// 密码展示
$(document).ready(function(){
  $("body").on("click",".psw-option-box",function(){
    $(this).toggleClass("active");
    $(this).closest('.t4s_field').find('input').attr("type", $(this).hasClass("active") ? "text" : "password");
  })
}) 
 


  $(document).ready(function(){
    function checkFormFilled($form) {
      // All visible, enabled input/textarea/select fields except hidden
      var $inputs = $form.find("input, textarea, select").filter(function() {
        var $el = $(this);
        // Exclude hidden fields and disabled fields
        if ($el.is(":hidden") || $el.is(":disabled")) return false;
        // If has 'required' attr, must be filled. If no 'required', still check
        return true;
      });
      var allFilled = true;
      $inputs.each(function(){
        var $el = $(this);
        if ($el.is('[type="checkbox"], [type="radio"]')) {
          // for checkbox/radio, at least one in group must be checked
          var name = $el.attr('name');
          // Only check for first in group
          if (name && $form.find('[name="'+name+'"]').length > 1) {
            var $group = $form.find('[name="'+name+'"]');
            if ($group.filter(':checked').length === 0) {
              allFilled = false;
              return false; // break
            }
          } else {
            if (!$el.is(':checked')) {
              allFilled = false;
              return false;
            }
          }
        } else if ($el.is('[type="file"]')) {
          if (!$el[0].files || $el[0].files.length === 0) {
            allFilled = false;
            return false;
          }
        } else {
          if (($el.val() || "").trim() === "") {
            allFilled = false;
            return false;
          }
        }
      });
      return allFilled;
    }

    function toggleAlreadyBoxForForm($form) {
      var $btns = $form.find('button[type="submit"], button.t4s_btn_submmit, button[type="button"].t4s_btn_submmit, button.t4s_btn_submmit');
      if (checkFormFilled($form)) {
        $btns.addClass('already-box');
      } else {
        $btns.removeClass('already-box');
      }
    }

    // 先循环计时器判断是否有#login_login-sidebar，再加载toggleAlreadyBoxForForm
    var loginSidebarCheckCount = 0;
    var loginSidebarCheckInterval = setInterval(function() {
      if ($('#login_login-sidebar').length > 0 || loginSidebarCheckCount > 30) {
        clearInterval(loginSidebarCheckInterval);
        $('form').each(function(){
          var $form = $(this);
          // Listen to input and change events on all fillable fields
          $form.on('input change', 'input, textarea, select', function() {
            toggleAlreadyBoxForForm($form);
          });
          // Also run on page load
          toggleAlreadyBoxForForm($form);
        });
      }
      loginSidebarCheckCount++;
    }, 100);


  });

/**
 * ============================================================
 * Warranty 联动删除
 * ------------------------------------------------------------
 * 机制：checkout 插件在 warranty 行的 line item properties 写入
 *   `_warranty_sku` = 对应主产品的 variant SKU（见模板 data-warranty-sku）。
 * 行为：
 *   1. 删除「主产品行」时，自动把购物车里 `data-warranty-sku`
 *      等于该行 `data-sku` 的 warranty 行一并删除；
 *   2. 删除「warranty 行」本身时，只删自己，不连带主产品；
 *   3. 兜底（warranty 行尚未写 _warranty_sku 的过渡期）：
 *      若购物车里恰好只有一行标题含关键词的 warranty，删除产品时联动删除它。
 * 实现：document capture 阶段拦截 [data-cart-remove] 点击，
 *      有联动时阻止主题默认删除（interactable.min.js），改走一次
 *      /cart/update.js 批量置 0；无联动时完全放行原逻辑。
 * ============================================================
 */
(function () {
  if (window.__drexeyWarrantyLinkedRemoval) return;
  window.__drexeyWarrantyLinkedRemoval = true;

  // 兜底识别关键词（大小写不敏感）。只保留几乎不会出现在普通产品名里的词，
  // 避免 'protection' 误匹配 "Screen Protector" 之类的普通商品。
  // 兜底仅用于插件尚未写入 _warranty_sku 的过渡期；插件上线后走精确联动。
  var WARRANTY_KEYWORDS = ['warranty', '延保', '质保'];

  function getCartRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    if (window.T4Sroutes && T4Sroutes.root_url) return T4Sroutes.root_url;
    return '';
  }

  // 行的 line key：删除按钮/数量 input 上都带 data-id="{{ item.key }}"
  function getRowKey(row) {
    var btn = row.querySelector('[data-cart-remove]');
    if (btn && btn.getAttribute('data-id')) return btn.getAttribute('data-id');
    var input = row.querySelector('[data-quantity-value]');
    if (input && input.getAttribute('data-id')) return input.getAttribute('data-id');
    return null;
  }

  function getRowTitle(row) {
    var el = row.querySelector('[class*="__title"]');
    return el ? (el.textContent || '').trim() : '';
  }

  function titleMatchesKeywords(row) {
    var title = getRowTitle(row).toLowerCase();
    return WARRANTY_KEYWORDS.some(function (kw) {
      return kw && title.indexOf(kw.toLowerCase()) !== -1;
    });
  }

  // 返回需要连同删除的行（不含当前行）；空数组 = 无联动
  function findLinkedRows(row) {
    // warranty 行自己：只删自己
    if ((row.getAttribute('data-warranty-sku') || '').trim()) return [];

    var sku = (row.getAttribute('data-sku') || '').trim();
    // 只搜索当前行所在的购物车容器（mini cart 抽屉或购物车页），
    // 避免另一容器中的陈旧 DOM（行 key 已失效）干扰匹配。
    var wrapper = row.closest('[data-cart-wrapper]');
    var scope = wrapper || document;
    var rows = Array.prototype.slice.call(scope.querySelectorAll('[data-cart-item]'));
    var linked = [];
    var isWarrantyRow = titleMatchesKeywords(row);

    // 精确联动：找 data-warranty-sku === 本行 data-sku 的其他行。
    // 依赖主产品 variant SKU 唯一；若两个不同变体共用同一 SKU，会连带删除它们的 warranty 行。
    if (sku) {
      linked = rows.filter(function (r) {
        return r !== row && (r.getAttribute('data-warranty-sku') || '').trim() === sku;
      });
    }

    // 兜底：本行不是 warranty，且购物车里恰好只有一行标题含关键词
    if (!linked.length && !isWarrantyRow) {
      var kwMatches = rows.filter(function (r) {
        return r !== row && titleMatchesKeywords(r);
      });
      if (kwMatches.length === 1) linked = kwMatches;
    }

    return linked;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cart-remove]') : null;
    if (!btn) return;
    var row = btn.closest('[data-cart-item]');
    if (!row) return;

    var linked = findLinkedRows(row);
    if (!linked.length) return; // 无联动，放行主题原有删除逻辑

    e.preventDefault();
    e.stopImmediatePropagation(); // 阻止 interactable.min.js 的 data-cart-remove handler

    var updates = {};
    var mainKey = getRowKey(row);
    if (mainKey) updates[mainKey] = 0;
    linked.forEach(function (r) {
      var k = getRowKey(r);
      if (k) updates[k] = 0;
    });
    if (!Object.keys(updates).length) return;

    var sections = 'cart_data,mini_cart';
    if (window.cartT4SectionID) sections += ',' + window.cartT4SectionID;

    function handleSuccess(result) {
      if (typeof T4SThemeSP !== 'undefined' && T4SThemeSP.Cart) {
        if (result.data.sections && typeof T4SThemeSP.Cart.renderContents === 'function') {
          T4SThemeSP.Cart.renderContents(result.data.sections);
        } else if (typeof T4SThemeSP.Cart.getToFetch === 'function') {
          T4SThemeSP.Cart.getToFetch();
        }
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (typeof jQuery !== 'undefined') {
        jQuery(document).trigger('cart:updated');
      }
    }

    function sendRemove(updates) {
      return fetch((getCartRoot() || '') + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          updates: updates,
          sections: sections,
          sections_url: window.location.pathname
        })
      }).then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      });
    }

    sendRemove(updates)
      .then(function (result) {
        if (!result.ok) throw result.data;
        handleSuccess(result);
      })
      .catch(function (err) {
        console.error('[drexey-warranty-remove]', err);
        // 联动行的 line key 可能已失效（陈旧 DOM）导致整单失败：
        // 把主产品行单独重试一次，保证主产品至少能删掉。
        if (mainKey && Object.keys(updates).length > 1) {
          var mainOnly = {};
          mainOnly[mainKey] = 0;
          sendRemove(mainOnly)
            .then(function (result) {
              if (!result.ok) throw result.data;
              handleSuccess(result);
            })
            .catch(function (err2) {
              console.error('[drexey-warranty-remove] retry failed', err2);
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            });
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      });
  }, true); // capture 阶段，先于主题的 jQuery 委托 handler
})();


(function () {
  var loaded = Object.create(null);
  var selector = 'script[data-drexey-component-script]';
  function load(marker) {
    var src = marker.getAttribute('data-drexey-component-script');
    if (!src || loaded[src]) return;
    loaded[src] = true;
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onerror = function () { delete loaded[src]; };
    document.head.appendChild(script);
  }
  function scan(root) {
    if (root.nodeType === 1 && root.matches(selector)) load(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(load);
  }
  $(function () {
    scan(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
